// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (max-width: 1280px){.navigation-links__links.dashboard{max-width:380px !important}.navigation-links__links.dashboard li{margin:0;padding:0 10px}.navigation-links__links.dashboard li a[data-automation-id=NavigationPricing]{padding:0 10px}}.converters{width:220px !important}.navigation-links__links__item .drop .drop__trigger{font-size:16px !important;padding:9px 5px !important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
